import React from 'react';
import {Box, Heading, VStack} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import InternalTemplate from '../../../../../../components/templates/internal';
import {StackParamList} from '../../../../../../navigators';
import {DashboardItem} from '../../../../../../components/dashboard';

import SalesOrderIcon from '../../../../../../components/icons/sales-order';
import {message as t} from '../../../../../../utils/messages';
import {useSalesmanContext} from '../../../../../../context/salesman';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'OrderDashboardScreen'
>;

const OrderDashboardScreen = ({navigation}: ScreenProps) => {
  const {resetNewOrder} = useSalesmanContext();

  const handleGoBack = () => {
    navigation.goBack();
  };

  const Icon = () => {
    return (
      <Box mt={2}>
        <SalesOrderIcon width={40} />
      </Box>
    );
  };

  const handleCreateNewOrder = () => {
    resetNewOrder();
    navigation.navigate('SalesmanOrderBegin', {fromTemplate: false});
  };

  const handleCreateNewOrderFromHistory = () => {
    resetNewOrder();
    navigation.navigate('OrderListCandidateScreen');
  };

  return (
    <InternalTemplate
      title={'salesman-order-dashboard-title'}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'go-back',
        usage: 'external',
      }}>
      <VStack marginX={5} space={3}>
        <Heading fontSize={'md'} color={'#06355E'} fontWeight={'medium'}>
          {t('salesman-order-dashboard-summary')}
        </Heading>
        <DashboardItem
          label="salesman-order-dashboard-create-title"
          icon={<Icon />}
          shadow={false}
          onPress={() => handleCreateNewOrder()}
        />
        <DashboardItem
          label="salesman-order-dashboard-create-from-history-title"
          icon={<Icon />}
          shadow={false}
          onPress={() => handleCreateNewOrderFromHistory()}
        />
      </VStack>
    </InternalTemplate>
  );
};
export default OrderDashboardScreen;
